import { render, staticRenderFns } from "./CadastroRegiaoCD.vue?vue&type=template&id=5f894319&"
import script from "./CadastroRegiaoCD.vue?vue&type=script&lang=js&"
export * from "./CadastroRegiaoCD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports